import { render, staticRenderFns } from "./ProductSeo.vue?vue&type=template&id=907cac7a&scoped=true&"
import script from "./ProductSeo.vue?vue&type=script&lang=js&"
export * from "./ProductSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907cac7a",
  null
  
)

export default component.exports